/** Разделы страницы расчёта в кабинете клиента: каждый — пункт бокового меню и адрес /calculations/:id/<раздел>. */
export type CalcSection = 'overview' | 'payments' | 'invoice' | 'freight' | 'permits';

export interface CalcSectionInfo {
  id: CalcSection;
  labelKey: string;
  fallback: string;
}

/** Первым — сводка всех расходов; дальше разделы в порядке работы: инвойс → перевозка (от неё зависят платежи) → платежи → документы. */
export const CALC_SECTIONS: CalcSectionInfo[] = [
  { id: 'overview', labelKey: 'calcSections.overview', fallback: 'Стоимость поставки' },
  { id: 'invoice', labelKey: 'calcSections.invoice', fallback: 'Цифровой инвойс' },
  { id: 'freight', labelKey: 'calcSections.freight', fallback: 'Прогноз перевозки' },
  { id: 'payments', labelKey: 'calcSections.payments', fallback: 'Таможенные платежи' },
  { id: 'permits', labelKey: 'calcSections.permits', fallback: 'Разрешительные документы' }
];

export const DEFAULT_CALC_SECTION: CalcSection = 'overview';

/**
 * Роли, которые видят расчёт в кабинете с разделами; брокер и поставщик — в прежнем виде.
 * Админ смотрит расчёт глазами клиента — тот же кабинет, но без действий клиента.
 */
export const CALC_CABINET_ROLES = ['ROLE_PUBLIC', 'ROLE_CARGO_OWNER', 'ROLE_ADMIN'];

export function toCalcSection(value: string | null | undefined): CalcSection {
  return CALC_SECTIONS.some(s => s.id === value) ? (value as CalcSection) : DEFAULT_CALC_SECTION;
}
